// import analyticsActions from './analyticsActions';
import actions from '../index';

const tourbookPageLoad = (tourbookId: string) => async dispatch => {
  await dispatch(actions.setTourbookExternalListingPage(tourbookId));
};

export default tourbookPageLoad;
